// extracted by mini-css-extract-plugin
module.exports = {"page":"pagination_page__289kN","active":"pagination_active__aTmrY","arrow":"pagination_arrow__1JC3K","previous":"pagination_previous__EVPfT","disable":"pagination_disable__13dfy"};